<div class="flex items-center justify-between mb1">
  <div>
    <span class="font-medium bold mr2">{{ documentName }}</span>
    <app-button-file-input (fileChange)="onFileChange($event)"
      ><lib-button weight="tertiary">{{
        'DOCUMENT_CARD.REPLACE_DOCUMENT' | translate
      }}</lib-button></app-button-file-input
    >
  </div>

  <div>
    <lib-button
      *ngIf="canRemoveFile"
      weight="tertiary"
      icon="delete"
      (click)="removeDocument.emit()"
      >{{ 'DOCUMENT_CARD.REMOVE_FROM_LIST' | translate }}
    </lib-button>
  </div>
</div>

<div class="col-12 mb2">
  <table mat-table [dataSource]="clients" class="app-doc-relation-table col-12">
    <ng-container matColumnDef="clientName">
      <th mat-header-cell *matHeaderCellDef class="app-client-cell">
        {{ 'DOCUMENT_CARD.DOCUMENT_PERMISSION' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row | personFullName }}</td>
    </ng-container>

    <ng-container [matColumnDef]="clientDocumentRelationEnum.CannotRead">
      <th mat-header-cell *matHeaderCellDef class="app-relation-cell">
        {{ 'DOCUMENT_CARD.DONT_SHOW' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index" class="app-relation-cell app-even-cell">
        <ng-container
          *ngTemplateOutlet="
            signerRadioTmp;
            context: {
              client: row,
              index: i,
              clientDocRelation: clientDocumentRelationEnum.CannotRead
            }
          "
        ></ng-container>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="clientDocumentRelationEnum.CanRead">
      <th mat-header-cell *matHeaderCellDef class="app-relation-cell">
        {{ 'DOCUMENT_CARD.TO_VIEW' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index" class="app-relation-cell">
        <ng-container
          *ngTemplateOutlet="
            signerRadioTmp;
            context: {
              client: row,
              index: i,
              clientDocRelation: clientDocumentRelationEnum.CanRead
            }
          "
        ></ng-container>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="clientDocumentRelationEnum.MustRead">
      <th mat-header-cell *matHeaderCellDef class="app-relation-cell">
        {{ 'DOCUMENT_CARD.MANDATORY_TO_READ' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index" class="app-relation-cell app-even-cell">
        <ng-container
          *ngTemplateOutlet="
            signerRadioTmp;
            context: {
              client: row,
              index: i,
              clientDocRelation: clientDocumentRelationEnum.MustRead
            }
          "
        ></ng-container>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="clientDocumentRelationEnum.MustSign">
      <th mat-header-cell *matHeaderCellDef class="app-relation-cell">
        {{ 'DOCUMENT_CARD.TO_SIGN' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index" class="app-relation-cell">
        <ng-container
          *ngTemplateOutlet="
            signerRadioTmp;
            context: {
              client: row,
              index: i,
              clientDocRelation: clientDocumentRelationEnum.MustSign
            }
          "
        ></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="sign-fields">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row; let i = index">
        <ng-container *ngIf="signFields">
          <ng-container
            *ngTemplateOutlet="
              clientSignFieldsTmp;
              context: {
                client: row,
                index: i,
                isSigner: formArray.at(i).value === clientDocumentRelationEnum.MustSign,
                hasSignField: (signFields | filterSignFieldsBySigner : row).length
              }
            "
          ></ng-container>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
  </table>
</div>

<ng-template
  #signerRadioTmp
  let-client="client"
  let-index="index"
  let-clientDocRelation="clientDocRelation"
>
  <mat-radio-group *ngIf="canEditDocSigners" [formControl]="formArray.at(index)">
    <mat-radio-button
      class="app-doc-relation-radio"
      [value]="clientDocRelation"
      [name]="getRadioName(client)"
      [disabled]="!canEditDocSigners"
      [checked]="formArray.at(index).value === clientDocRelation"
    ></mat-radio-button>
  </mat-radio-group>

  <lib-icon
    *ngIf="!canEditDocSigners"
    icon="{{ formArray.at(index).value === clientDocRelation ? 'check_circle' : 'highlight_off' }}"
  ></lib-icon>
</ng-template>

<ng-template
  #clientSignFieldsTmp
  let-client="client"
  let-index="index"
  let-isSigner="isSigner"
  let-hasSignField="hasSignField"
>
  <div *ngIf="canEditDocSigners" class="inline-flex flex-wrap items-center py1">
    <div>
      <lib-button
        weight="tertiary"
        [disabled]="!canEditDocSigners || !isSigner"
        (click)="editSignFields.emit(client)"
      >
        {{ 'DOCUMENT.SIGN_FIELD_SETTINGS' | translate }}
      </lib-button>
    </div>

    <div class="app-sign-field-set-wrapper pl2">
      <div *ngIf="isSigner" class="flex items-center">
        <ng-container *ngIf="hasSignField">
          <lib-icon
            icon="check_circle_outline"
            [inline]="true"
            class="mr1 font-large app-text--secondary"
          ></lib-icon
          >{{ 'DOCUMENT_CARD.SET' | translate }}
        </ng-container>

        <ng-container *ngIf="!hasSignField">
          <lib-icon
            icon="highlight_off"
            [inline]="true"
            class="mr1 font-large"
            [class.app-sing-field-not-set]="!hasSignField"
          ></lib-icon
          >{{ 'DOCUMENT_CARD.UNSET' | translate }}
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
